export default __webpack_public_path__ + "static/media/input-onlinegiftools.abe6a22f.png";